import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthService} from 'src/app/auth';
import {FormBuilder, Validators} from '@angular/forms';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import set = Reflect.set;
import {Subject} from "rxjs";
import {map, switchMap} from "rxjs/operators";
import {environment} from "../../../../environments/environment";

declare var $: any;

@Component({
  selector: 'app-login',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss']
})
export class SSOComponent implements OnInit {
  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private fb: FormBuilder,
    private notification: NzNotificationService,
  ) {
  }

   ngOnInit() {
      this.activeRoute.queryParams.pipe(switchMap(res => {
        return  this.authService.loginWithSSO(res.token);
      })).subscribe(item => {
        console.log('item' , item)
        if (item.code === 1  ) {
          this.notification.create('success' , 'Thành công' , 'Đăng nhập thành công');
          localStorage.setItem('currentUser', JSON.stringify(item.data));
          this.authService.currentUserSubject.next(item.data);
          this.router.navigate(['/business/dashboard']);
        }
      }, error => {

      });


  }

  redirect() {
    // window.location.href =  environment.redirect_domain;
  }
}
